<script>
import paperViewDialog from "./paperViewDialog.vue";
import { EXAMINATION } from "@/utils/data";
export default {
  name: "paperDialog",
  components: { paperViewDialog },
  props: {
    title: {
      type: String,
      default: "弹窗",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "create",
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      CREATE_TYPE: EXAMINATION.CREATE_TYPE,
      CREATE_TYPE_LIST: EXAMINATION.CREATE_TYPE_LIST,
      TYPE_LIST: EXAMINATION.TYPE_LIST,
      show: false,
      loading: false,
      questionList: [],
      treeCategory: [],
      form: {
        id: "",
        createType: EXAMINATION.CREATE_TYPE.AUTO,
        category: [],
        categoryName: [],
        name: "",
        score: 0,
        questionList: [],
        questionCount: {
          single: {
            value: 0,
            max: 0,
          },
          multiple: {
            value: 0,
            max: 0,
          },
          trueOrFalse: {
            value: 0,
            max: 0,
          },
          blank: {
            value: 0,
            max: 0,
          },
          input: {
            value: 0,
            max: 0,
          },
        },
      },
      rules: {
        category: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入题目", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
      },
      paperViewDialog: {
        visible: false,
        name: "",
        score: "",
        questionList: [],
      },
    };
  },
  watch: {
    visible(val) {
      this.show = val;
      if (this.type === "create") {
        this.form.id = "";
        this.form.createType = EXAMINATION.CREATE_TYPE.AUTO;
        this.form.category = [];
        this.form.categoryName = [];
        this.form.name = "";
        this.form.score = 0;
        this.form.questionList = [];
        this.form.questionCount = {
          single: {
            value: 0,
            max: 0,
          },
          multiple: {
            value: 0,
            max: 0,
          },
          trueOrFalse: {
            value: 0,
            max: 0,
          },
          blank: {
            value: 0,
            max: 0,
          },
          input: {
            value: 0,
            max: 0,
          },
        };
        this.getQuestion();
      }
      if (this.type === "edit" || this.type === "view") {
        this.form.id = this.data.id;
        this.form.createType = EXAMINATION.CREATE_TYPE.CUSTOMER;
        this.form.category = this.data.category || [];
        this.form.categoryName = this.data.categoryName || [];
        this.form.name = this.data.name;
        this.form.score = this.data.score;
        this.form.questionList = [];
        this.getQuestion();
        if (val) {
          this.getPaper();
        }
      }
    },
  },
  mounted() {
    this.show = this.visible;
    this.loadCategory();
    this.changeCreateType();
  },
  methods: {
    loadCategory() {
      this.$cloud.get("/category/index").then((data) => {
        this.treeCategory = data;
      });
    },
    getQuestion() {
      this.$cloud
        .get("examination/question/list", {
          page: 1,
          size: 9999,
          categoryId: this.form.category[this.form.category.length - 1],
        })
        .then((res) => {
          this.questionList = res.children.map((v) => {
            v["key"] = v.id;
            v["label"] = `[${v.typeName}][${v.score}分]${v.name}`;
            return v;
          });
          console.log("this.questionList", this.questionList);
          // 生成限制值
          for (const questionCountType in this.form.questionCount) {
            let count = this.questionList.filter(
              (x) => x.type === questionCountType
            ).length;
            console.log(questionCountType, count);
            this.form.questionCount[questionCountType].max = count;
            this.form.questionCount[questionCountType].value = 0;
          }
        });
    },
    getPaper() {
      console.log("获取试卷信息", this.data);
      this.$cloud
        .get("examination/paper/detail", { id: this.data.id })
        .then((res) => {
          console.log("试卷信息", res);
          this.form.name = res.name;
          this.form.score = res.score;
          this.form.category = res.category;
          this.form.categoryName = res.categoryName;
          if (this.type === "view") {
            this.form.questionList = res.questionList;
          } else {
            this.form.questionList = res.questionList.map((v) => v.id);
          }
          console.log("form", this.form);
        });
    },
    calculateScore() {
      console.log("计算分数", this.form);
      if (this.form.createType === EXAMINATION.CREATE_TYPE.CUSTOMER) {
        let score = 0;
        this.form.questionList.forEach((id) => {
          let question = this.questionList.find((v) => v.id === id);
          score += question.score;
        });
        this.form.score = score;
      }
    },
    handleClose() {
      console.log("关闭");
      this.$refs.form.clearValidate();
      this.$emit("update:visible", false);
    },
    handlePreview() {
      console.log("预览", this.form.questionList);
      let questionList = [];
      if (this.type === "create" || this.type === "edit") {
        console.log("this.questionList", this.questionList);
        if (this.form.createType === EXAMINATION.CREATE_TYPE.CUSTOMER) {
          this.form.questionList.forEach((id) => {
            let question = this.questionList.find((v) => v.id === id);
            questionList.push(question);
          });
        }
        if (this.form.createType === EXAMINATION.CREATE_TYPE.AUTO) {
          questionList = this.form.questionList;
        }
      }
      if (this.type === "view") {
        questionList = this.form.questionList;
      }
      console.log("form", this.form.name);
      console.log("questionList", questionList);
      this.paperViewDialog.name = this.form.name;
      this.paperViewDialog.score = this.form.score;
      this.paperViewDialog.questionList = questionList;
      this.paperViewDialog.visible = true;
    },
    handleSubmit() {
      console.log("数据", this.form);
      console.log("类型", this.type);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.calculateScore();
          if (this.type === "create") {
            let data = {
              categoryName: this.form.categoryName,
              category: this.form.category,
              name: this.form.name,
              score: this.form.score,
              questionList: this.form.questionList,
            };
            if (this.form.createType === EXAMINATION.CREATE_TYPE.AUTO) {
              data.questionList = this.form.questionList.map((v) => v.id);
            }
            this.$cloud
              .post("examination/paper/add", data)
              .then(() => {
                this.loading = false;
                this.$message.success("保存成功");
                this.handleClose();
                this.$emit("refresh");
              })
              .catch((err) => {
                console.log("err", err);
                this.loading = false;
              });
          }
          if (this.type === "edit") {
            let data = {
              id: this.form.id,
              categoryName: this.form.categoryName,
              category: this.form.category,
              name: this.form.name,
              score: this.form.score,
              questionList: this.form.questionList,
            };
            if (this.form.createType === EXAMINATION.CREATE_TYPE.AUTO) {
              data.questionList = this.form.questionList.map((v) => v.id);
            }
            this.$cloud
              .post("examination/paper/edit", data)
              .then(() => {
                this.loading = false;
                this.$message.success("保存成功");
                this.handleClose();
                this.$emit("refresh");
              })
              .catch((err) => {
                console.log("err", err);
                this.loading = false;
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleChangeCategory() {
      if (this.$refs["refSubCat"].getCheckedNodes()[0]) {
        this.form["categoryName"] =
          this.$refs["refSubCat"].getCheckedNodes()[0].pathLabels;
        // 清空选中题目
        this.form.questionList = [];
        this.getQuestion();
      }
    },
    changeCreateType() {
      console.log("this.form.createType", this.form.createType);
      switch (this.form.createType) {
        case EXAMINATION.CREATE_TYPE.CUSTOMER:
          // 清空
          this.form.questionList = [];
          break;
        case EXAMINATION.CREATE_TYPE.AUTO:
          // 清空
          this.form.questionList = [];
          EXAMINATION.TYPE_LIST.forEach((x) => {
            this.form.questionCount[x.value].value = 0;
          });
          break;
      }
      console.log("this.form.", this.form);
    },
    handleCreateQuestion() {
      console.log("生成", this.form.questionCount);
      this.form.questionList = [];
      let score = 0;
      for (const type in this.form.questionCount) {
        if (this.form.questionCount[type].value > 0) {
          let typeList = this.questionList.filter((x) => x.type === type);
          console.log("typeList", typeList);
          for (let i = 0; i < this.form.questionCount[type].value; i++) {
            let index = Math.floor(Math.random() * typeList.length);
            console.log("index", index);
            let question = typeList[index];
            this.form.questionList.push(question);
            score += question.score;
            typeList.splice(index, 1);
          }
        }
      }
      this.form.score = score;
    },
  },
};
</script>

<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      width="1000px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        class="p-6"
      >
        <el-form-item label="分类" prop="category" v-if="false">
          <el-cascader
            :disabled="type === 'view'"
            v-model="form.category"
            :props="{ checkStrictly: true }"
            ref="refSubCat"
            :options="treeCategory"
            @change="handleChangeCategory"
            :placeholder="
              form.categoryName.length > 0
                ? form.categoryName.join('/')
                : '请选择课程分类'
            "
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="试卷名" prop="name">
          <el-input
            v-model="form.name"
            :disabled="type === 'view'"
            placeholder="亲输入试卷名"
          ></el-input>
        </el-form-item>
        <el-form-item label="总分"> {{ form.score }}分 </el-form-item>
        <el-form-item label="添加方式" prop="name" v-if="type !== 'view'">
          <el-radio-group v-model="form.createType" @change="changeCreateType">
            <el-radio
              :label="item.value"
              v-for="item in CREATE_TYPE_LIST"
              :key="'createType' + item.value"
              >{{ item.name }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <!--        手动添加-->
        <el-form-item
          label="题目"
          v-if="form.createType === CREATE_TYPE.CUSTOMER"
        >
          <el-transfer
            v-if="type !== 'view'"
            filterable
            :button-texts="['移除', '添加']"
            :titles="['题库', '已添加']"
            @change="calculateScore"
            class="w-full"
            v-model="form.questionList"
            :data="questionList"
          >
          </el-transfer>
          <el-table
            v-else
            height="400px"
            :data="form.questionList"
            style="width: 100%"
          >
            <el-table-column prop="typeName" label="类型"> </el-table-column>
            <el-table-column prop="score" label="分值"> </el-table-column>
            <el-table-column prop="name" label="题目"> </el-table-column>
          </el-table>
        </el-form-item>
        <!--        自动添加-->
        <el-form-item label="题目" v-if="form.createType === CREATE_TYPE.AUTO">
          <div class="flex" v-if="type !== 'view'">
            <div class="w-52">
              <div v-for="item in TYPE_LIST" :key="'type' + item.value">
                {{ item.name }}：<el-input-number
                  v-model="form.questionCount[item.value].value"
                  :min="0"
                  :max="form.questionCount[item.value].max"
                />
              </div>
            </div>
            <div>
              <el-button type="warning" @click="handleCreateQuestion"
                >生成试卷试题</el-button
              >
            </div>
          </div>
          <div class="mt-4">
            <el-table
              :data="form.questionList"
              border
              height="300px"
              row-class-name="row-class"
              style="width: 100%"
            >
              <el-table-column type="index" label="编号" width="60">
              </el-table-column>
              <el-table-column prop="name" label="题目名称"> </el-table-column>
              <el-table-column prop="score" label="题目分值" width="80">
              </el-table-column>
              <el-table-column prop="answerStr" label="题目答案" width="120">
              </el-table-column>
              <el-table-column prop="typeName" label="题目类型" width="100">
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mr-2" @click="handlePreview">预览试卷</el-button>
        <span v-if="type === 'view'">
          <el-button @click="handleClose">关 闭</el-button>
        </span>
        <span v-else>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" :loading="loading" @click="handleSubmit"
            >保 存</el-button
          >
        </span>
      </span>
    </el-dialog>
    <paper-view-dialog
      :visible.sync="paperViewDialog.visible"
      :name="paperViewDialog.name"
      :score="paperViewDialog.score"
      :questionList="paperViewDialog.questionList"
    />
  </div>
</template>

<style scoped>
.row-class {
  padding: 0;
}
</style>
